import {Menu}         from "../../../shared-gen/Model/Menus/Menu";
import {MenuPageFun}  from "./menu-page.fun";
import {getDefaultID} from "../../core";
import {Product}      from '../../../shared-gen/Model/Products/Product';
import {ProductBase}  from '../../../shared-gen/Model/Products/ProductBase';
import { EntityType } from "../../../shared-gen/Model/Utils/EntityType";

export class MenuFun {

	static createNew(provider: string): Menu {
		return {
			Type: EntityType.Menu,
			ID: getDefaultID(),
			Hash: '',
			Name: '',
			AutoStartPage: false,
			Pages: [MenuPageFun.createNew()],
			ProviderID: provider
		};
	}

	static findProductBase(menu: Menu, product: Product): ProductBase | null {
		if (!product)
			return null;
		for (let menuPage of menu.Pages) {
			for (let cell of menuPage.Cells) {
				if (cell && cell.Product) {
					if (cell.Product.Instances.findIndex(it => {
						return it.ID === product.ID;
					}) !== -1) {
						return cell.Product;
					}
				}
			}
		}
		return null;
	}

	/**
	 * Gets all products from the given menu.
	 * This method returns only the first available instance of each product in the menu.
	 */
	static getAllProducts(menu: Menu): Product[] {
		const ret: Product[] = [];
		for (let menuPage of menu.Pages) {
			for (let cell of menuPage.Cells) {
				if (cell && cell.Product) {
					const product = cell.Product.Instances[0];
					if (false == ret.some(it => it.ID == product.ID))
						ret.push(product);
				}
			}
		}
		return ret;
	}

}
